import { FC, useMemo, useState } from "react";

import { SearchSelectInput } from ".";
import _ from "lodash";
import { useClassOfBusinesses } from "hooks/data/use-class-of-business";
import { useInsurers } from "hooks/data/use-insurers";

interface Option {
  label: {
    title: string;
    imageUrl?: string;
  };
  value: string | object;
}

interface RegularBusinessPickerProps {
  id: string;
  label: string;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  labelHidden?: boolean;
  values: any;
  errors?: any;
  touched?: any;
  optionsLoading?: boolean;
  setFieldValue: any;
  setFieldTouched: any;
  setFieldError: any;
  rounded?: boolean;
  rawId?: boolean;
  description?: string;
  multiple?: boolean;
}

const RegularBusinessPicker: FC<RegularBusinessPickerProps> = ({
  id,
  label,
  rawId,
  description,
  labelHidden,
  required,
  multiple,
  ...form
}) => {
  const { classOfBusinesses, loading } = useClassOfBusinesses({
    page: 1,
    pageSize: 500,
    search: "",
  });
  const [query] = useState("");
  const options = useMemo(
    () =>
      classOfBusinesses.map(({ ...rest }) => ({
        label: rest.business_name,
        value: rawId ? rest?.class_of_business_id : { ...rest },
      })),
    [classOfBusinesses]
  );

  const filteredOptions =
    query === ""
      ? options
      : options.filter((option) => {
          return option.label?.toLowerCase().includes(query.toLowerCase());
        });

  return (
    <SearchSelectInput
      id={id ?? ""}
      label={label ?? ""}
      labelHidden={labelHidden}
      description={description}
      required={required}
      multiple={multiple}
      placeholder={loading ? "Loading please wait ..." : "Search Business"}
      optionsLoading={loading}
      rawId={rawId}
      options={(filteredOptions || [])?.map((item: any) => ({
        label: {
          title: item.label as string,
        },
        value: item?.value?.toString(),
      }))}
      {...form}
    />
  );
};

export default RegularBusinessPicker;
